export default __webpack_public_path__ + "static/media/diggletModel.20e45dd4.glb";